import { combineReducers } from 'redux';
import configureStore from './CreateStore';
import rootSaga from '../Sagas/';
import { Router, Route } from 'react-router';
import { routerReducer } from 'react-router-redux';

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
    user: require('./UserRedux').reducer,
    auth: require('./AuthRedux').reducer,
    ot: require('./OtRedux').reducer,
    customer: require('./CustomerRedux').reducer,
    changelog: require('./ChangelogRedux').reducer,
    entity: require('./EntityRedux').reducer,
    product: require('./ProductRedux').reducer,
    report: require('./ReportRedux').reducer,
    unit: require('./UnitRedux').reducer,
    routing: routerReducer,
})

export default () => {
  let { store, sagasManager, sagaMiddleware } = configureStore(reducers, rootSaga)

  if (module.hot) {
    module.hot.accept(() => {
      const nextRootReducer = require('./').reducers
      store.replaceReducer(nextRootReducer)

      const newYieldedSagas = require('../Sagas').default
      sagasManager.cancel()
      sagasManager.done.then(() => {
        sagasManager = sagaMiddleware.run(newYieldedSagas)
      })
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/Redux/index.js